export default __webpack_public_path__ + "static/media/Carousel-1.b093ab8e.webp";